<template>
  <div class="login-container">
    <el-form @submit.prevent="login" :model="form" ref="form" :rules="rules"  class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <img src="@/assets/img/logo.svg" width="300">
        <h3 class="title">Recuperar contraseña</h3>
      </div>
      <p v-if="okmsg" style="color: green">{{okmsg}}</p>
      <p v-if="errormsg" style="color: red">{{errormsg}}</p>
      <p>Ingrese el correo electrónico que utiliza en ECOPETROL para que le enviemos un email con los pasos a seguir para recuperar su contraseña.</p>
      <el-form-item prop="email">
        <el-input v-model="form.email" placeholder="Email" type="text"/>
      </el-form-item>
      <el-button type="primary" style="width:100%;margin-bottom:30px;" :loading="loadingButton" @click="recovery">Recuperar</el-button>

      <div>
        <span>Si ya tiene una cuenta puede <router-link :to="{ name: 'Login' }">Entrar</router-link></span>
      </div>
    </el-form>
  </div>
</template>
<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      form: {
        email: '',
      },
      errormsg: '',
      okmsg: '',
      loadingButton: false,
      rules: {
        email: [
          {
            required: true,
            message: "Debe ingresar un correo electrónico",
            trigger: "blur"
          }
        ],
      }
    };
  },
  methods: {
    recovery() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          // Valid form
          this.loadingButton = true
          var auth = firebase.auth()
          this.errormsg = ''
          this.okmsg = ''
          
          await auth.sendPasswordResetEmail(this.form.email).then( () => {
            this.okmsg = 'Enviamos un correo electrónico a ' + this.form.email + ' con los pasos a seguir'
            this.form.email = ''
          }, error => {
            if( error.code == 'auth/user-not-found' || error.code === 'auth/invalid-email' )
              this.errormsg = 'El correo electrónico ingresado es incorrecto'
            else
              this.errormsg = 'Hubo un error, intente nuevamente'
          })
          this.loadingButton = false
        }
      })
    }
  }
}
</script>
